// Import firebase services
import { firebaseAuth } from '@/firebase/firebase-config'

export const InvoiceEventsRepository = {

	/*
	**  Set up the data
	*/

	data: () => ({
        new_invoice_event: {
            id: null,
            type: null,
            meta: {
                created_at: moment().unix(),
                updated_at: moment().unix(),
                deleted_at: null,
                app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
                version: 1
            },
            attributes: {
                title: null,
                ip_address: null,
                application: null,
                source: null,
                request: null,
                response: null
            },
            links: null,
            metrics: null,
            relationships: {
                invoice: null,
                resident: null,
                unit: null,
                property: null,
                company: null,
                lease: null,
                rent: null,
                user: firebaseAuth.currentUser.uid
            }
        }
    }),

    /*
	**  Set the methods
	*/

	methods: {

        resetNewInvoiceEvent: function() {

            // Reset the new event
            this.new_invoice_event = {
                id: null,
                type: null,
                meta: {
                    created_at: moment().unix(),
                    updated_at: moment().unix(),
                    deleted_at: null,
                    app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
                    version: 1
                },
                attributes: {
                    title: null,
                    ip_address: null,
                    application: null,
                    source: null,
                    request: null,
                    response: null
                },
                links: null,
                metrics: null,
                relationships: {
                    invoice: null,
                    resident: null,
                    unit: null,
                    property: null,
                    company: null,
                    lease: null,
                    rent: null
                }
            };

        }

    }

}